import './CreateModel.css';
import Header from '../../components/Header/Header';
import { useState } from 'react';

export default function CreateModel(){

    const [Builder, setBuilder] = useState('Models');

    function handleBuilder(builder){
        setBuilder(builder);
    }

    return (
        <>
            <Header ></Header>
            <div className='create-model-container'>
                
                a
            </div>
            <div className="builders">
                    <button 
                        className='builder-pro-option'
                        onClick={() => handleBuilder("Models")}>
                            Models
                        <i className={Builder === "Models" ? "arrown down" : "arrown right"}></i>
                    </button>
                    <button 
                        className='builder-pro-option'
                        onClick={() => handleBuilder("Datasets")}>
                            Datasets
                        <i className={Builder === "Datasets" ? "arrown down" : "arrown right"}></i>
                    </button>
                    <button 
                        className='builder-pro-option'
                        onClick={() => handleBuilder("Endpoints")}>
                            Endpoints
                        <i className={Builder === "Endpoints" ? "arrown down" : "arrown right"}></i>
                    </button>
            </div>
        </>
    )
}